<template>
  <Feature heading="Contact" backgroundColor="#c0853f">
    <b-col>
      <div class="mb-1" style="margin-top: -1rem">
        <small>I am located in</small>
      </div>
      <p class="mb-4">Auckland, New Zealand</p>
      <b-img
        src="https://www.gravatar.com/avatar/b0dd37ea721e8f860f9f17ea8b1cc76e?s=150"
        alt="Brett, the geeky helper"
        width="150px"
        rounded="circle"
        class="mb-4"
      >
      </b-img>
      <p>
        <a
          v-b-popover.hover.bottom="'twoteesbrett@gmail.com'"
          href="mailto:twoteesbrett@gmail.com"
          ><b-icon-envelope-fill
        /></a>
        &nbsp;
        <!-- <a
          v-b-popover.hover.bottom="'instagram.com/thegeekyhelpernz'"
          href="https://www.instagram.com/thegeekyhelpernz"
          target="_blank"
          rel="noopener noreferrer"
          ><b-icon-instagram
        /></a>
        &nbsp;
        <a
          v-b-popover.hover.bottom="'facebook.com/thegeekyhelpernz'"
          href="https://www.facebook.com/thegeekyhelpernz"
          target="_blank"
          rel="noopener noreferrer"
          ><b-icon-facebook
        /></a>
        &nbsp;
        <a
          v-b-popover.hover.bottom="'@thegeekyhelpernz'"
          href="https://m.me/thegeekyhelpernz"
          target="_blank"
          rel="noopener noreferrer"
          ><b-icon-chat-dots-fill
        /></a>
        &nbsp; -->
        <a
          v-b-popover.hover.bottom="'linkedin.com'"
          href="https://www.linkedin.com/in/brett-fisher-43079a182/"
          target="_blank"
          rel="noopener noreferrer"
          ><b-icon-linkedin
        /></a>
        &nbsp;
        <a
          v-b-popover.hover.bottom="'github.com/twoteesbrett'"
          href="https://github.com/twoteesbrett"
          target="_blank"
          rel="noopener noreferrer"
          ><b-icon-github
        /></a>
      </p>
    </b-col>
  </Feature>
</template>

<script>
import {
  // BIconChatDotsFill,
  BIconEnvelopeFill,
  // BIconFacebook,
} from "bootstrap-vue";

import Feature from "@/components/home/Feature.vue";

export default {
  name: "Contact",
  components: {
    // BIconChatDotsFill,
    BIconEnvelopeFill,
    // BIconFacebook,
    Feature,
  },
};
</script>

<style scoped>
</style>
